var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_206_382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.453 274.411C504.518 222.432 355.356 138.964 123.993 9.41873C108.394 -0.882857 90.4472 -2.23286 74.9409 3.01559L471.895 399.97L597.453 274.411Z",
    fill: "#32BBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9408 3.01562C72.0345 4 69.2064 5.1875 66.5017 6.62188C49.3782 15.8844 36.7954 33.7079 36.7954 56.2501V743.689C36.7954 766.231 49.3767 784.055 66.5017 793.316C69.2017 794.748 72.0283 795.941 74.9314 796.931L471.895 399.97L74.9408 3.01562Z",
    fill: "#32BBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.895 399.969L74.9314 796.931C90.4424 802.219 108.389 800.972 123.992 790.52C348.365 664.879 495.846 582.401 589.856 529.979C592.473 528.509 595.037 527.071 597.572 525.648L471.895 399.969Z",
    fill: "#32BBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7954 399.969V743.689C36.7954 766.231 49.3767 784.055 66.5017 793.316C69.2017 794.748 72.0283 795.941 74.9314 796.931L471.895 399.969H36.7954Z",
    fill: "#2C9FD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.992 9.41875C105.469 -2.81253 83.6252 -2.46409 66.5017 6.62343L465.87 405.993L597.451 274.411C504.518 222.432 355.355 138.964 123.992 9.41875Z",
    fill: "#29CC5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.873 393.948L66.5017 793.316C83.6267 802.402 105.469 802.927 123.992 790.52C348.365 664.88 495.846 582.401 589.856 529.979C592.473 528.509 595.037 527.071 597.572 525.648L465.873 393.948Z",
    fill: "#D93F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.205 399.97C763.205 380.923 753.594 361.701 734.545 351.041C734.545 351.041 698.922 331.165 589.729 270.09L459.849 399.97L589.856 529.978C697.85 469.342 734.544 448.896 734.544 448.896C753.594 438.238 763.205 419.016 763.205 399.97Z",
    fill: "#FFD500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.545 448.898C753.594 438.238 763.205 419.016 763.205 399.969H459.849L589.856 529.978C697.851 469.343 734.545 448.898 734.545 448.898Z",
    fill: "#FFAA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_206_382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.d2114f6e.svg";
export { ForwardRef as ReactComponent };